import {Component, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";

@Component({
  selector: 'micro-npRange-detail',
  templateUrl: './npRange-detail.component.html'
})
export class NpRangeDetailComponent extends BaseComponent {
  npRange:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/np/ranges/${id}`).subscribe(
            data => {
              this.npRange = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.npRange = {};
  }

  save() {
    if (!this.npRange.id) {
      this.http.post(`${this.env.e.url}/np/ranges`, this.npRange)
        .subscribe(
          data => {
            this.npRange = data;
            this.alertService.info(`Created ${this.npRange.regex}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/np/ranges/${this.npRange.id}`, this.npRange)
        .subscribe(
          data => {
            this.npRange = data;
            this.alertService.info(`Updated ${this.npRange.regex}`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/np/ranges/${this.npRange.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.npRange.regex}`);
          this.router.navigate(["/np/ranges"]);
        }
      );
  }
}
